import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'imageCardTitle',
    defaultMessage: 'Title',
  },
  text: {
    id: 'imageCardText',
    defaultMessage: 'Text',
  },
  link: {
    id: 'imageCardLink',
    defaultMessage: 'Link',
  },
  linkTitle: {
    id: 'imageCardLinkTitle',
    defaultMessage: 'Link title',
  },
  metadata: {
    id: 'imageCardMetadata',
    defaultMessage: 'Metadata',
  },
  image: {
    id: 'imageCardImage',
    defaultMessage: 'Image',
  },
  copyright: {
    id: 'imageCardCopyright',
    defaultMessage: 'Copyright',
  },
  imageCardsTitle: {
    id: 'Image Cards',
    defaultMessage: 'Image Cards',
  },
  imageCardsCardTitle: {
    id: 'imageCardsCardTitle',
    defaultMessage: 'Image Card',
  },
  display: {
    id: 'imageCardsDisplay',
    defaultMessage: 'Display',
  },
  images: {
    id: 'imageCardsImages',
    defaultMessage: 'Images',
  },
  addImagesDescription: {
    id: 'imageCardsAddImagesDescription',
    defaultMessage: 'Add a list of Images as Carousel Items',
  },
  imageScale: {
    id: 'imageCardsImageScale',
    defaultMessage: 'Image scale',
  },
  alignment: {
    id: 'imageCardsAlignment',
    defaultMessage: 'Alignment',
  },
  defaultFieldset: {
    id: 'defaultFieldsetTitle',
    defaultMessage: 'Default',
  },
  carousel: {
    id: 'carouselDefaultOption',
    defaultMessage: 'carousel',
  },
  imageCardsNull: {
    id: 'imageCardsNull',
    defaultMessage: 'No image cards',
  },
  slideCountTitle: {
    id: 'imageCardsSlideCountTitle',
    defaultMessage: 'Slides to show',
  },
  slideCountDescription: {
    id: 'imageCardsSlideCountDescription',
    defaultMessage: 'How many slides to show in one frame',
  },
  cardGrid: {
    id: 'Cards grid',
    defaultMessage: 'Cards grid',
  },
  gridSizeTitle: {
    id: 'gridSizeTitle',
    defaultMessage: 'Grid size',
  },
  themeTitle: {
    id: 'themeTitle',
    defaultMessage: 'Theme',
  },
  oneOption: {
    id: 'oneOption',
    defaultMessage: 'One',
  },
  twoOption: {
    id: 'twoOption',
    defaultMessage: 'Two',
  },
  threeOption: {
    id: 'threeOption',
    defaultMessage: 'Three',
  },
  fourOption: {
    id: 'fourOption',
    defaultMessage: 'Four',
  },
  defaultTheme: {
    id: 'defaultTheme',
    defaultMessage: 'Default',
  },
  primaryTheme: {
    id: 'primaryTheme',
    defaultMessage: 'Primary',
  },
  secondaryTheme: {
    id: 'secondaryTheme',
    defaultMessage: 'Secondary',
  },
  tertiaryTheme: {
    id: 'tertiaryTheme',
    defaultMessage: 'Tertiary',
  },
  settingsTitle: {
    id: 'carouselSettings',
    defaultMessage: 'Carousel Settings',
  },
  autoplayTitle: {
    id: 'autoplay',
    defaultMessage: 'Autoplay',
  },
  autoplaySpeedTitle: {
    id: 'autoplaySpeed',
    defaultMessage: 'Autoplay delay',
  },
  autoplaySpeedDescription: {
    id: 'autoplaySpeedDescription',
    defaultMessage: 'Delay between each auto scroll (in milliseconds)',
  },
  pauseOnHoverTitle: {
    id: 'pauseOnHover',
    defaultMessage: 'Pause on hover',
  },
  pauseOnHoverDescription: {
    id: 'pauseOnHoverDescription',
    defaultMessage: 'Prevents autoplay while hovering on track',
  },
  infiniteTitle: {
    id: 'infinite',
    defaultMessage: 'Infinite',
  },
  infiniteDescription: {
    id: 'infiniteDescription',
    defaultMessage: 'Infinitely wrap around contents',
  },
  hideArrowsTitle: {
    id: 'hideArrows',
    defaultMessage: 'Hide arrows',
  },
  hideNavigationDotsTitle: {
    id: 'hideNavigationDots',
    defaultMessage: 'Hide navigation dots',
  },
  fadeTitle: {
    id: 'fade',
    defaultMessage: 'Fade',
  },
  heightTitle: {
    id: 'cssHeight',
    defaultMessage: 'CSS height',
  },
  roundTile: {
    id: 'Round Tile',
    defaultMessage: 'Round Tile',
  },
  splashyCarousel: {
    id: 'Splashy Carousel',
    defaultMessage: 'Splashy Carousel',
  },
  discreetCarousel: {
    id: 'Discreet Carousel',
    defaultMessage: 'Discreet Carousel',
  },
});

export default messages;
